import { Clock, Calendar } from "lucide-react";
import { useTranslation } from "../i18n/I18nContext";

export const BundlePackageDetails = ({ packages }) => {
  const { t } = useTranslation();
  if (!Array.isArray(packages) || packages.length === 0) return null;
  return (
    <div className="space-y-2">
      {packages.map((p) => (
        <div
          key={p.id}
          className="rounded-lg border border-neutral-700 bg-neutral-800/40 p-2.5"
          data-testid={`bundle-pkg-${p.id}`}
        >
          <div className="flex items-center gap-2">
            <span className="text-[11px] px-1.5 py-0.5 rounded bg-red-600/20 text-red-400 border border-red-600/30 shrink-0">
              {p.level}
            </span>
            <span className="text-sm font-medium text-white truncate">{p.name}</span>
          </div>
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mt-1.5 text-xs text-neutral-400">
            <span className="flex items-center gap-1">
              <Clock className="w-3.5 h-3.5 text-red-500 shrink-0" />
              {p.total_sessions} {t("total_credits_label")} • {p.session_duration_minutes} {t("minutes_per_session")}
            </span>
            <span className="flex items-center gap-1">
              <Calendar className="w-3.5 h-3.5 text-red-500 shrink-0" />
              {p.duration_days} {t("days_access")}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BundlePackageDetails;
